import React, { useCallback, useEffect, useState } from 'react';
import { Button, Skeleton } from 'antd';
import '../assets/css/search-result-card.css';
import WavesIcon from '../assets/images/WavesIcon';

import DarkFish from '../../../../assets/images/Icons/SVG/BlueFish';
import RoundFavourite from '../assets/images/RoundFavourite';
import RightChevronCircle from '../../../../assets/images/RightChevronCircle';
import { Link } from 'react-router-dom';
import { useMarkFisheryAsFavouriteMutation } from '../../../fishery_profile/fisherySlice';
import WhiteFish from '../../../../assets/images/Icons/SVG/WhiteFish';
import dayjs from 'dayjs';
import Pound from '../assets/images/pound.svg';
import Time from '../assets/images/time.svg';
import { formatEventDate, formatEventTime } from '../../../../utils/date';


function SearchResultCardDetails({ data }) {
  const roundIconClasses = 'search-result__icon sb-blue-bg-700 brFull';

  const formattedDate = formatEventDate(data?.start_date);
  const formattedStartTime = formatEventTime(data?.start_time, data?.timezone, data?.start_date, false);
  const formattedEndTime = formatEventTime(data?.end_time, data?.timezone, false);

  const finalTime = `${formattedDate} | ${formattedStartTime} - ${formattedEndTime}`;

  return (
    <>
      <ul className='gMedium grey-600 search-result__bullets'>
        {Boolean(data?.num_lakes) && (
          <li>
            <span className={roundIconClasses}>
              <WavesIcon />
            </span>
            {finalTime}
          </li>
        )}
        {Boolean(data?.max_lbs) && (
          <li>
            <span className={roundIconClasses}>
              <WhiteFish />
            </span>
            Cost:{' '}
            {data?.cost_in_pence === 0 ? 'Free' : data?.cost_in_pence / 100}
          </li>
        )}
      </ul>
    </>
  );
}

export function SkeletonResultCard() {
  return (
    <div className='search-result__wrapper'>
      <div className='event-search-result'>
        <div className='search-result__image'>
          <Skeleton.Image active className={'w-full h-full br8'} />
        </div>
        <div className='search-result__details'>
          <Skeleton paragraph={{ rows: 3 }} active />
        </div>
        <div className='search-result__footer'>
          <Skeleton.Input active />
          <Skeleton.Button active style={{ width: '8rem' }} />
        </div>
      </div>
    </div>
  );
}

function SearchResultCard({
  fisheryId,
  name,
  address,
  thumbnail,
  initialIsFavourite,
  data = {},
  bookable = false,
  showDetails = true,
  adminImage,
  adminName,
  cost,
  startDate,
  timezone,
  startTime,
  endTime,
}) {
  const privateId = data.id;
  const [localIsFavourite, setLocalIsFavourite] = useState(initialIsFavourite);
  useEffect(() => {
    setLocalIsFavourite(initialIsFavourite);
  }, [initialIsFavourite]);

  const [markAsFavourite] = useMarkFisheryAsFavouriteMutation();
  const handleFavouriteToggle = useCallback(() => {
    markAsFavourite(privateId)
      .unwrap()
      .then(() => {
        setLocalIsFavourite((prev) => !prev);
      })
      .catch();
  }, [markAsFavourite, privateId]);


  const formattedDate = formatEventDate(startDate);
  const formattedStartTime = formatEventTime(startTime, timezone, startDate, false);
  const formattedEndTime = formatEventTime(endTime, timezone, startDate, false);

  const finalTime = `${formattedDate} | ${formattedStartTime} - ${formattedEndTime}`;

  return (
    <div className='search-result__wrapper'>
      {/* <Link to={'/fishery/' + fisheryId}>
        
      </Link> */}
      <Link to={`/event/${data?.id}`}>
        <div className='event-search-result cp'>
          <div className='search-result__image'>
            <img alt={name} src={thumbnail} loading={'lazy'} />
          </div>

          <div className='search-result__details'>
            <div className='search-result__titles'>
              <div className='search-result__title'>
                <h2 className='gBold sb-blue-700 lh-1.25'>{name}</h2>
                {/* {bookable && (
                  <RoundFavourite
                    className='search-result__fav cp'
                    isFavourite={localIsFavourite}
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      handleFavouriteToggle();
                    }}
                  />
                )} */}
              </div>
              <p className='gRegular sb-blue-700'>{address}</p>
              <div
                style={{
                  marginTop: '12px',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                }}
              >
                <div
                  style={{
                    borderRadius: '100px',
                    height: '24px',
                    width: '24px',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    backgroundColor: '#2772AF',
                  }}
                >
                  <img src={Time} alt='time' height='16px' width='16px' />
                </div>
                <div
                  className='gSemiBold'
                  style={{ color: '#174A73', fontSize: '13px' }}
                >
                  {finalTime}
                </div>
              </div>
              <div
                style={{
                  marginTop: '12px',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                }}
              >
                <div
                  style={{
                    borderRadius: '100px',
                    height: '24px',
                    width: '24px',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    backgroundColor: '#2772AF',
                  }}
                >
                  <img src={Pound} alt='pound' height='16px' width='16px' />
                </div>
                <div
                  className='gSemiBold'
                  style={{ color: '#174A73', fontSize: '13px' }}
                >
                  {`Cost: ${cost > 0 ? `£${cost / 100}` : 'FREE'}`}
                </div>
              </div>
            </div>

            {showDetails && <SearchResultCardDetails data={data} />}
          </div>

          <div className='search-result__footer'>
            <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
              <div
                style={{
                  border: '1px solid #174A73',
                  borderRadius: '100px',
                  height: '30px',
                  width: '30px',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <img
                  src={adminImage}
                  alt={adminName}
                  height='20px'
                  width='20px'
                />
              </div>
              <span
                className='gSemiBold'
                style={{ color: '#174A73', fontSize: '13px' }}
              >{`This event is being managed by: ${adminName}`}</span>
            </div>
            <span className='view-profile-button'>
              <Button
                className={
                  'br5 sb-blue-bg-500 hover:sb-blue-bg-700 border-1 sb-blue-border-300 hover:sb-blue-border-100 grey-100 gSemiBold row-center gap-05r pd-left-20 pd-right-20 h-fit pd-top-10 pd-bottom-10'
                }
              >
                <span className='lh-1'>View Event</span>
              </Button>
            </span>
          </div>
        </div>
      </Link>
    </div>
  );
}

export default SearchResultCard;
